module.exports = __webpack_public_path__ + "media/fail.40d3e12f.mp3";